import type { Location } from "history";
import queryString from "query-string";

export type QueryParams = Record<string, any>;

export function GetPathWithParams(
  originalPath: string,
  queryParams?: QueryParams,
): string {
  if (queryParams && Object.keys(queryParams).length) {
    return `${originalPath}?${queryString.stringify(queryParams)}`;
  } else {
    return originalPath;
  }
}

export function ParseParams(
  location: Location<any>,
  param: string,
): string | undefined {
  return queryString.parse(location.search)[param] as string | undefined;
}

export function GetBaseFileNameURL(url: string) {
  const urlSplit = url.split("/");
  return urlSplit[urlSplit.length - 1];
}
